<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'">
            <template #label="{user, name}">
              <span>{{ user.username }} - {{ name }}</span>
            </template>
          </DropdownScrollable>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="">
          <label class="txt-right required">Tên gói</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="package_obj.loading" width="100%" v-model="packages" :options="package_obj.items" :total="package_obj.total" @keyup="emitEventPackage" @offset="changeOffsetPackage"/>
          <input class="input_tmp_validator" id="package" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Thời hạn</label>
          <!-- <div class="p-col"> -->
          <div class="p-inputgroup text-box">
            <InputNumber
              v-model="value"
              class="input-text-box"
              placeholder="Nhập (Ngày)"
              suffix=" ngày"/>
          </div>
          <input class="input_tmp_validator" id="value" />
          <!-- </div> -->
        </div>
        <div class="mt-3 row text-box ml-0">
          <div class="p-col-6 pl-0">
            <label class="txt-right">Ngày hết hạn hiện tại</label>
            <div class="p-inputgroup">
              <Calendar v-model="expiration_date_old" disabled="disabled" dateFormat="dd/mm/yy"/>
            </div>
            <input class="input_tmp_validator" id="expiration_date_old" />
          </div>
          <div class="p-col-6 pr-0">
            <label class="txt-right">Sau kích hoạt</label>
            <div class="p-inputgroup">
              <Calendar v-model="expiration_date" disabled="disabled" dateFormat="dd/mm/yy"/>
            </div>
            <input class="input_tmp_validator" id="expiration_date" />
          </div>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Phí</label>
          <!-- <div class="p-col"> -->
          <div class="p-inputgroup text-box">
            <InputNumber
              v-model="fee"
              class="input-text-box"
              placeholder="Nhập (đ)"
              suffix=" đ"/>
          </div>
          <input class="input_tmp_validator" id="fee" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right">Phương thức thanh toán</label>
          <!-- <div class="p-col"> -->
          <div class="p-inputgroup text-box">
            <DropdownScrollable width="100%" defaultValue="value" defaultLabel="label" v-model="type_payment" :options="type_payment_list" disabled="disabled"/>
          </div>
          <input class="input_tmp_validator" id="fee" />
          <!-- </div> -->
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      filters: {},
      name: "",
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      package_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      packages: {},
      fee: null,
      value: null,
      type_payment: null,
      type_payment_list: [{value: "TRANSFER", label: 'Chuyển khoản công ty'}],
      expiration_date_old: null,
      expiration_date: null,
      time_zone_local : moment.tz.guess(true),
    };
  },
  watch: {
    "company"() {
      this.expiration_date_old = null;
      this.expiration_date = null;
      if (!this.$commonFuction.isEmptyObject(this.company)) {
        this.expiration_date_old = this.company?.expiration_date ? new Date(this.company.expiration_date) : null;
        if (!this.$commonFuction.isEmpty(this.value) && !this.$commonFuction.isEmpty(this.expiration_date_old)) {
          this.expiration_date = moment.tz(moment.tz(this.expiration_date_old, this.time_zone_local).format("yyyy-MM-DD"), this.time_zone_local).add(this.value, 'days').format("DD/MM/yyyy");
          if (this.expiration_date_old <= new Date()) {
            this.expiration_date = moment.tz(moment.tz(new Date(), this.time_zone_local).format("yyyy-MM-DD"), this.time_zone_local).add(this.value, 'days').format("DD/MM/yyyy");
          }
        }
      }
    },
    "packages"() {
      if (!this.$commonFuction.isEmptyObject(this.packages)) {
        this.fee = this.packages.fee;
        this.value = this.packages.value;
      }
    },
    "value"() {
      console.log(this.value);
      if (!this.$commonFuction.isEmpty(this.value)) {
        if (!this.$commonFuction.isEmpty(this.expiration_date_old)) {
          this.expiration_date = moment.tz(this.expiration_date_old, this.time_zone_local).add(this.value, 'days').format("DD/MM/yyyy");
          if (this.expiration_date_old <= new Date()) {
            this.expiration_date = moment.tz(moment.tz(new Date(), this.time_zone_local).format("yyyy-MM-DD"), this.time_zone_local).add(this.value, 'days').format("DD/MM/yyyy");
          }
        } else {
          this.expiration_date = moment.tz(new Date(), this.time_zone_local).add(this.value, 'days').format("DD/MM/yyyy");
        }
      } else {
        this.expiration_date = null;
      }
    }
  },
  async mounted() {
      await this.getListCompany();
      await this.getListPackage();
      this.type_payment = {value: "TRANSFER", label: 'Chuyển khoản công ty'};
      if (!this.$commonFuction.isEmpty(this.company_id) && (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        setTimeout(() => {
          this.$set(this, 'company', {id: this.company_id});
        }, 200);
      }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },

    async emitEventPackage(keyword) {
      this.$delete(this.package_obj.filters, 'name');
      if (keyword) {
        this.package_obj.filters.name = keyword;
      }
      await this.getListPackage();
    },
    async changeOffsetPackage(value) {
      this.package_obj.offset = value;
      // await this.getListPackage();
    },
    async getListPackage() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.package_obj.loading = true;
        await ApiRepository.post("/_api/packages/options", {filters: this.package_obj.filters, offset: this.package_obj.offset, limit: this.package_obj.limit}, {headers}).then((res) => {
            if (this.package_obj.offset > 0) {
            this.package_obj.items.push(...res.data.data.packages);
          } else {
            this.package_obj.items = res.data.data.packages;
          }
            this.package_obj.total = res.data.data.total;
            this.package_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.package_obj.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let value_add = document.getElementById("value");
      if (
        this.$commonFuction.isEmpty(this.value)
      ) {
        value_add.setCustomValidity("Thời hạn không được để trống!");
      } else {
        value_add.setCustomValidity("");
      }

      let fee_add = document.getElementById("fee");
      if (
        this.$commonFuction.isEmpty(this.fee)
      ) {
        fee_add.setCustomValidity("Phí không được để trống!");
      } else {
        fee_add.setCustomValidity("");
      }

      let package_add = document.getElementById("package");
      if (
        this.$commonFuction.isEmptyObject(this.packages)
      ) {
        package_add.setCustomValidity("Tên gói không được để trống!");
      } else {
        package_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        company: this.company,
        package: this.packages,
        fee: this.fee,
        value: this.value
      };
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
input:disabled {
  cursor: no-drop;
  background-color: #EEEEEE;
  color: #666666;
}
</style>
